import { Card, Typography, TypographyType } from '../../components';
import { useAppSelector } from '../../hooks';
import { TextColor } from '../../types';

const SeatCards = () => {
  const { organization } = useAppSelector((state) => state.auth);

  const { adminSeats = 0, repSeats = 0, managerSeats = 0, userSeats } = organization || {};

  // Total allowed seats
  const totalAdminAndManagerSeats = adminSeats + managerSeats;
  const totalRepSeats = repSeats;

  // Used seats
  const usedAdminAndManagerSeats = (userSeats?.ADMIN || 0) + (userSeats?.MANAGER || 0);
  const usedRepSeats = userSeats?.SALES_REP || 0;

  // Available seats
  // If used seats are more than total seats, it means total seats aren't correctly updated in retool, set available seats to 0
  const availableAdminAndManagerSeats = Math.max(0, totalAdminAndManagerSeats - usedAdminAndManagerSeats);
  const availableRepSeats = Math.max(0, totalRepSeats - usedRepSeats);

  const cards = [
    {
      title: 'Admin & managers',
      usedSeats: usedAdminAndManagerSeats,
      availableSeats: availableAdminAndManagerSeats,
    },
    {
      title: 'Representatives',
      usedSeats: usedRepSeats,
      availableSeats: availableRepSeats,
    },
  ];

  return (
    <div className="flex w-full gap-8">
      {cards.map(({ title, usedSeats, availableSeats }) => (
        <Card gap={4} key={title}>
          <Typography type={TypographyType.BASE}>{title}</Typography>
          <Typography type={TypographyType.H1}>{usedSeats}</Typography>
          <Typography type={TypographyType.X_SMALL} color={TextColor.SECONDARY}>
            {availableSeats} more available
          </Typography>
        </Card>
      ))}
    </div>
  );
};

export default SeatCards;
